export { InfoChip } from './info-chip';
